export default {
  bankCashflow: []
}
